export default {
  bankCashflow: []
}
